var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-progress-circular',{attrs:{"indeterminate":"","size":_vm.size,"color":_vm.color}})}
var staticRenderFns = []

export { render, staticRenderFns }